import { Controller } from "stimulus";

const CLASS_OPEN = 'is-fixed-open';

export default class extends Controller {
    static targets = [ 'fixed', 'burger' ];
    opened = false;

    connect() {
    }

    open() {
        this.opened = true;
        this.fixedTarget.classList.add(CLASS_OPEN);
        this.burgerTarget.classList.add(CLASS_OPEN);
    }

    close() {
        this.opened = false;
        this.fixedTarget.classList.remove(CLASS_OPEN);
        this.burgerTarget.classList.remove(CLASS_OPEN);
    }

    toggle() {
        if (this.opened) this.close();
        else this.open();
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/nav_controller.js